import type { NavigationState } from './slice';

/**
 * Selects the navigation permissions data from the slice state.
 * Wire to the root state in the consumer app, e.g.:
 * ```ts
 * const selectNavigation = (state: RootState) => selectNavigationData(state.navigationPermissions);
 * ```
 */
export const selectNavigationData = (state: NavigationState) => state.data;

/**
 * Selects whether navigation permissions are currently loading.
 */
export const selectNavigationIsLoading = (state: NavigationState) => state.isLoading === 'pending';

/**
 * Selects whether the last navigation permissions request has failed.
 */
export const selectNavigationHasFailed = (state: NavigationState) => state.isLoading === 'error';

/**
 * Selects the principal key for which navigation permissions are currently cached.
 */
export const selectNavigationPrincipalKey = (state: NavigationState) => state.principalKey;
